module.exports = __webpack_public_path__ + "static/img/correct.53cff23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/correct.jpg
// module id = rC1+
// module chunks = 1